<template>
    
    <div class="row">
      <div class="row">
        <h5>
          Total Deposit Driver Periode {{ periode }} :
          <a href="#">Rp. {{saldo_akhir}}</a>
          
        </h5>
      </div>
      <br/>
      <br/>
      <vue-good-table
        title="list-of-orders"
        mode="remote"
        @on-page-change="onPageChange"
        @on-sort-change="onSortChange"
        @on-column-filter="onColumnFilter"
        @on-per-page-change="onPerPageChange"
        :line-numbers="true"
        :isLoading.sync="isLoading"
        :pagination-options="{
          enabled: false,
        }"
        :filterOptions="{
          enabled: false}" 
        :rows="rowsTableOrder"
        :columns="columnsOrder"
        :sort-options="{
          enabled: false,
        }"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'debit'">
            {{ props.row.debit.toLocaleString('id-ID') }} 
          </span>
  
          <span v-else-if="props.column.field == 'kredit'">
            {{ props.row.kredit.toLocaleString('id-ID') }} 
          </span>

          <span v-else-if="props.column.field == 'saldo'">
            {{ props.row.saldo.toLocaleString('id-ID') }} 
          </span>
  
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
          
        </template>
      </vue-good-table>
  
      <!-- <modal-trip-analysis  
        :showModal="showModalNow"
        :data="detailTripAnalysis"
        :vehicle_no="vehicle_no"
        @closeModal="closeMyModal"
      ></modal-trip-analysis> -->
  
  
  
    </div>
  
  
  </template>
  
  
  <script>
//   import modalTripAnalysis from "@/components/modal/modalTripAnalysis.vue";
  
  export default {
    name: "depositComponent",
    props: {
      detail: [],
      periode: String
    },
    // components: {
    //   "modal-trip-analysis":  modalTripAnalysis ,
    //   // DirectionsRenderer,
    // },
    watch: {          
      detail: function(val) {
        this.loadTable(val);
      },
    
    },
    data() {
      return {
        //vehicle_no:this.$route.params.vehicle_no,
        detailTripAnalysis:"",
        showModalNow: false,
        isLoading: false,
        totalRecords: 0,
        serverParams: {
          columnFilters: {},
          sort: {
            field: "",
            type: "",
          },
          page: 1,
          per_page: 10,
        },
        rowsTableOrder: [],
        saldo_akhir:'0',
        columnsOrder: [          
          {
            label: "Tanggal",
            field: "posting_date",
          },
          {
            label: "Keterangan",
            field: "keterangan",
          },
          {
            label: "Debit",
            field: "debit",
          },
          {
            label: "Kredit",
            field: "kredit",
          },
          {
            label: "Saldo",
            field: "saldo",
          },
  
        ],
        //
      };
    },
    methods: {  
      loadTable(val){
         this.rowsTableOrder=val;
         if(val.length === 0){
          this.saldo_akhir = '0';
         }else{
          this.saldo_akhir = val[val.length - 1].saldo.toLocaleString('id-ID');
         }                
      },
  
      updateParams(newProps) {
        this.serverParams = Object.assign({}, this.serverParams, newProps);
      },
  
      onColumnFilter(params) {
        params.page = 1;
        this.updateParams(params);
      },
  
      onPageChange(params) {
        this.updateParams({ page: params.currentPage });
      },
  
      onSortChange(params) {
        this.updateParams({
          sort: {
            type: params[0].type,
            field: params[0].field,
          },
        });
      },
  
  
      EditFormModal(data) {
        this.detailTripAnalysis=data;
        this.showModalNow = !this.showModalNow;
      },
  
      closeMyModal() {
        this.showModalNow = false;
        this.$emit("afterSaveTripAnalysis");
        //this.loadData(this.vehicle_no);
      },
  
      onPerPageChange(params) {
        this.updateParams({ per_page: params.currentPerPage });
      },
    },
  };
  </script>
  